import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Country } from '@tiendanube/common/src/enums';
import { ORDERS_CHARGEBACK_ENABLED } from 'App/featuresFlags';
import { useAppDispatch } from 'App/store';
import { useGetCountry, useGetTags } from 'domains/Auth/hooks';
import { useKycStatus } from 'domains/NuvemPagoCommons/hooks/useKycStatus';
import { getOrdersChargeback, fetchOrdersChargebacks } from '../../ordersSlice';

const countriesEnabledForChargeback = [Country.AR];

function useOrdersChargeback() {
  const { isKycRejected } = useKycStatus();
  const tags = useGetTags();
  const country = useGetCountry();
  const isTagEnabled = tags.includes(ORDERS_CHARGEBACK_ENABLED);
  const dispatch = useAppDispatch();
  const chargebackFetchedRef = useRef(false);

  const isChargebackAvailable = useMemo(
    () =>
      countriesEnabledForChargeback.includes(country) &&
      !isKycRejected &&
      isTagEnabled,
    [country, isKycRejected, isTagEnabled],
  );

  const getChargebacks = useCallback(
    () => dispatch(fetchOrdersChargebacks()),
    [dispatch],
  );
  const chargebacksList = useSelector(getOrdersChargeback);

  useEffect(() => {
    if (!isChargebackAvailable || chargebackFetchedRef.current) {
      return;
    }
    getChargebacks();
    chargebackFetchedRef.current = true;
  }, [getChargebacks, isChargebackAvailable]);

  return {
    chargebacks: chargebacksList,
    getChargebacks,
    isChargebackAvailable,
  };
}

export default useOrdersChargeback;
